module.exports = __WEBPACK_EXTERNAL_MODULE_72__;


//////////////////
// WEBPACK FOOTER
// external "ReactRouter"
// module id = 72
// module chunks = 0 1